import { Button, Card, useTranslation } from '@hbs-us/ui';
import { Link } from '@tanstack/react-router';

/**
 * Company-setup nudge (prod DashboardPage companyConfigured banner): shown ONLY
 * when the tenant's company profile is incomplete, linking to Settings so the user
 * can finish it. Rendered at the top of the Home screen. Token-styled only.
 */

export function SetupNudge() {
  const { t } = useTranslation();
  return (
    <Card elevation={0} className="flex flex-wrap items-center justify-between gap-3 bg-secondary/50 p-4">
      <div className="min-w-0">
        <p className="font-semibold text-foreground text-sm">{t('home:setup.heading')}</p>
        <p className="mt-0.5 text-muted-foreground text-xs">{t('home:setup.body')}</p>
      </div>
      <Button asChild size="sm" variant="outline">
        <Link to="/settings">{t('home:setup.cta')}</Link>
      </Button>
    </Card>
  );
}
